import { InputModel } from '../components/input/input.model';
import { RequiredModel } from '../components/input/rules/implementations/required.model';
import { CreditCardNumberModel } from '../components/input/rules/implementations/creditCardNumber.model';
import { CreditCardExpirationDateModel } from '../components/input/rules/implementations/creditCardExpirationDate.model';
import { CreditCardCVVModel } from '../components/input/rules/implementations/creditCardCVV.model';

export class CreditCardPayModel {
  ownerId: string;
  name: string;
  number: string;
  brand: number;
  flag: string;
  type = 1;
  securityCode: string;
  expirationDate: string;
  monthExp: number;
  yearExp: number;


  cpf: string;
  numero: string;
  codigoSeguranca: string;
  nome: string;
  mesAnoValidade: string;
  bandeira: number;

  creditCardNumber = new InputModel(false, false, 'tel', 'Número do Cartão', [new RequiredModel(), new CreditCardNumberModel()],
    new CreditCardNumberModel());
  creditCardExpirationDate = new InputModel(false, true, 'tel', 'Data validade',
    [new RequiredModel(), new CreditCardExpirationDateModel()],
    new CreditCardExpirationDateModel());
  creditCardCVV = new InputModel(false, true, 'tel', 'CVV', [new RequiredModel()], new CreditCardCVVModel());
  creditCardHolderName = new InputModel(false, false, 'text', 'Nome do titular', [new RequiredModel()]);
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/creditCardPay.model.ts